import React, { useState, useEffect, useRef } from "react";
import styles from "./CustomSelect.module.css";
import arrowIcon from "./Path 89188.svg";

const CustomSelect = ({
                          data = [],
                          valueKey = "id",
                          displayKey = "name",
                          placeholder = "Select...",
                          selected = "",
                          valueSetter = () => {},
                          error = false,
                          style = {},
                          disabled = false,
                      }) => {
    const [open, setOpen] = useState(false);
    const [selectedValue, setSelectedValue] = useState(selected);
    const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0, width: 0 });

    const selectRef = useRef(null);

    const lockScroll = () => {
        document.body.style.overflow = "hidden";
        document.body.style.position = "fixed";
        document.body.style.width = "100%";
    };

    const unlockScroll = () => {
        document.body.style.overflow = "";
        document.body.style.position = "";
        document.body.style.width = "";
    };

    useEffect(() => {
        setSelectedValue(selected);
    }, [selected]);

    useEffect(() => {
        valueSetter(selectedValue);
    }, [selectedValue]);

    const selectedItem = data.find(
        (item) => String(item[valueKey]) === String(selectedValue)
    );

    const handleSelect = (value) => {
        setSelectedValue(value);
        setOpen(false);
    };

    useEffect(() => {
        if (open) lockScroll();
        else unlockScroll();
        return () => unlockScroll();
    }, [open]);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (selectRef.current && !selectRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        if (open && selectRef.current) {
            const rect = selectRef.current.getBoundingClientRect();
            setDropdownPos({
                top: rect.bottom + window.scrollY + 4,
                left: rect.left + window.scrollX,
                width: rect.width,
            });
        }
    }, [open]);

    return (
        <div
            className={`${styles.selectContainer} ${error ? styles.error : ""} ${
                disabled ? styles.disabled : ""
            }`}
            style={style}
            ref={selectRef}
        >
            <div
                className={styles.select}
                onClick={() => !disabled && setOpen((prev) => !prev)}
            >
        <span
            className={`${styles.selectText} ${
                !selectedItem ? styles.placeholder : ""
            }`}
        >
          {selectedItem ? selectedItem[displayKey] : placeholder}
        </span>
                <img
                    src={arrowIcon}
                    alt="arrow"
                    className={`${styles.selectIcon} ${open ? styles.rotated : ""}`}
                />
            </div>

            <div
                className={`${styles.dropdown} ${open ? styles.dropdownOpen : ""}`}
                style={{
                    top: dropdownPos.top,
                    left: dropdownPos.left,
                    width: dropdownPos.width,
                }}
            >
                {data.map((item) => (
                    <div
                        key={item[valueKey]}
                        className={`${styles.option} ${
                            selectedValue === item[valueKey] ? styles.selected : ""
                        }`}
                        onClick={() => handleSelect(item[valueKey])}
                    >
                        {item[displayKey]}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CustomSelect;